import createComponent, { ComponentProps } from '../utils/createComponent';
export type TagGroupProps = ComponentProps;

const TagGroup = createComponent({ name: 'TagGroup' });

export default TagGroup;
